var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({
	html:true,
	title:_vm.tip,
	interactive:false,
	variant: _vm.variant,
}),expression:"{\n\thtml:true,\n\ttitle:tip,\n\tinteractive:false,\n\tvariant,\n}"}],staticClass:"tip-ico",attrs:{"name":_vm.icon}})}
var staticRenderFns = []

export { render, staticRenderFns }